export default "__VITE_ASSET__DWd0tpGo__"